import { useQuery } from "@tanstack/react-query";
import { get } from "../services/apiClient";

export interface CollectMetadata {
  month: string;
  collectedBy: { userId: string; name: string };
}

export interface TransactionRow {
  id: string;
  ownerId: string;
  subscriptionId: string | null;
  gateway: string;
  amount: string | number;
  currency: string;
  status: string;
  type: string;
  paidAt: string | null;
  createdAt: string;
  metadata?: CollectMetadata | Record<string, unknown> | null;
  owner?: { id: string; name: string; phone: string } | null;
  subscription?: { id: string; planId: string } | null;
}

interface TransactionListResponse {
  data: TransactionRow[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

interface TransactionListParams {
  page?: number;
  limit?: number;
  ownerId?: string;
  gateway?: string;
}

export const useTransactionList = (params: TransactionListParams = {}) =>
  useQuery<TransactionListResponse>({
    queryKey: ["transactions", "list", params],
    queryFn: () => get<TransactionListResponse>("/admin/transactions", params),
    retry: false,
  });
